import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
  NbLogoutComponent
} from './@auth/components/';
import { AuthGuard } from './@core/guards'


export const routes: Routes = [
  {
    path: 'pages',
    //path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'editors',
    loadChildren: () => import('./pages/editors/editors.module').then(m => m.EditorsModule)
  },
  // // Custom auth module.
  {
    path: 'auth',
    loadChildren: () => import('./@auth/auth.module')
      .then(m => m.NbAuthModule)
  },
  { path: '', redirectTo: 'pages', pathMatch: 'full' },
  { path: '**', redirectTo: '' }
  //{ path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, config)
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
